import { v4 as uuid } from "uuid";
import { z } from "zod";
export var NotificationType;
(function (NotificationType) {
    NotificationType["PROJECT_REPORT_SUBMITTED"] = "notification-type_project_report_submission";
    NotificationType["MONTHLY_REPORT_SUBMITTED"] = "notification-type_monthly_report_submitted";
    NotificationType["MONTHLY_REPORT_REJECTED"] = "notification-type_monthly_report_rejected";
    NotificationType["MONTHLY_REPORT_ACCEPTED"] = "notification-type_monthly_report_accepted";
    NotificationType["SUBCONTRACTOR_ACCEPTED"] = "notification-type_subcontractor_accepted";
    /**
     * Email-only: no notification row is ever written with this type. It exists so
     * product update emails opt out through the same `disabled_notification_types`
     * array as everything else — default-on for free, no schema change, and one
     * Settings list rather than two.
     */
    NotificationType["PRODUCT_UPDATES"] = "notification-type_product_updates";
})(NotificationType || (NotificationType = {}));
export const notificationSchema = z.object({
    /** Canonical (suffix-stripped) form of organisation_name, derived by the
     * database. Optional: absent on payloads predating the derived column. */
    canonical_name: z.string().nullish(),
    contractor_package_id: z.string(),
    created: z.date(),
    deleted: z.boolean().optional(),
    notification_id: z.string(),
    organisation_id: z.string(),
    /** Fetched via JOIN from organisation table */
    /** Fetched via JOIN from organisation table */
    organisation_logo: z.string().optional(),
    organisation_name: z.string().optional(),
    project_id: z.string(),
    /** Fetched via JOIN from project table */
    project_name: z.string().optional(),
    report_id: z.string().optional(),
    type: z.enum(NotificationType),
    // User-specific view status (only present when using WithUserStatus functions)
    user_viewed: z.boolean().optional(),
    viewed_at: z.date().optional()
});
export const notificationUserViewSchema = z.object({
    created: z.date(),
    notification_id: z.string(),
    notification_user_view_id: z.string(),
    profile_id: z.string(),
    viewed: z.boolean(),
    viewed_at: z.date().optional()
});
export const createDefaultNotification = (organisationId, projectId, contractorPackageId, notificationType, reportId) => {
    return {
        contractor_package_id: contractorPackageId,
        created: new Date(),
        deleted: false,
        notification_id: uuid(),
        organisation_id: organisationId,
        project_id: projectId,
        report_id: reportId,
        type: notificationType
    };
};
